module.exports = __webpack_public_path__ + "img/appliances.e52f08bf.png";